import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';

/** PUT `/admin/passwordChange/{newPassword}` — updates password for signed-in user. */
export function usePasswordChangeMutation() {
  return useApiMutation(
    (newPassword) => `/admin/passwordChange/${encodeURIComponent(newPassword)}`,
    'put',
    {},
    {
      onSuccess: () => {
        NotificationManager.success('Password changed', '', 3000);
      },
      onError: (err) => {
        NotificationManager.error(
          err.message || 'Could not change password',
          '',
          4000,
        );
      },
    },
  );
}
